import React from 'react';
import { Navigate } from 'react-router-dom';

export default function Preferences({token, setToken}) {

  if (!token) {
    return <Navigate to='/login?next=preferences' />;
  }

  return(
    <h2>Preferences</h2>
  );
}